import React from 'react';
import { SvgIcon } from 'ui/SvgIcon';
import Article from 'ui/Icons/components/Article.component';
import { theme } from '../../../tailwind.config';
import { IDocumentLinksProps } from './types';

export const DocumentLinks = (props: IDocumentLinksProps) => {
  const { documents, baseUrlPath, title, className = '' } = props;

  if (documents.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {title && (
        <span
          className="font-noe-display text-26px text-brown-prime font-normal block mb-[10px]"
          style={{ lineHeight: '1.276em' }}
        >
          {title}
        </span>
      )}
      <div className="flex flex-row flex-wrap gap-[20px]">
        {documents.map((document, index) => (
          <a
            key={`${document.path}-${index}`}
            href={`${baseUrlPath}${document.path}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-row items-center gap-[5px] cursor-pointer hover:opacity-80 transition-opacity"
          >
            <SvgIcon
              IconComponent={Article}
              defaultFill={theme.colors['brown-prime']}
              hoverFill={theme.colors['brown-hard']}
              defaultBackground={theme.colors['transparent']}
              width="18px"
              height="18px"
            />
            <span
              className="font-hurmegeometric-sans text-14px text-brown-prime underline"
              style={{ lineHeight: '1.429em' }}
            >
              {document.displayName}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};
